import { Services } from '@smiles/voebiz-core-corporate-club';
import { IUpdateBeneciaryList } from '@smiles/voebiz-core-corporate-club/dist/Types/UpdateBeneficiariesApi.types';
import { GetCorporateClubParamType } from '@smiles/voebiz-core-corporate-club/dist/Types/GetCorporateClubApi.types';
import dayjs from 'dayjs';
import { GetBeneficiariesParams } from '../types/beneficiaries';
import { IMember } from '../contexts/SelectedMembers';
import { parseJwt } from '../utils/decodeJWT';
import { GetCorporateClub } from './types/type';
import * as mocked100 from '../mocks/getBeneficiariesCorpClubMockManyRows100.json';

export async function getBeneficiariesList({
  currentPlanList,
  availablePlans,
  search = '',
  pageSize,
  startRowNum,
  createdStart,
  createdEnd,
}: GetBeneficiariesParams = {}) {
  console.log('currentPlanList: ', currentPlanList);
  console.log('availablePlans: ', availablePlans);

  const getToken = parseJwt(`${localStorage.getItem('session-token')}`);

  const getMemberNumberVoeBiz = getToken?.sub.split('|')[2];

  const payload = {
    memberNumberVoeBiz: getMemberNumberVoeBiz,
    search,
    pageSize,
    startRowNum,
  };

  const payLoadParams = {
    memberNumberVoeBiz: getMemberNumberVoeBiz,
    search,
    currentPlanList,
    createdStart,
    createdEnd,
    pageSize,
    startRowNum,
    availablePlans,
  };

  if (typeof createdStart === 'undefined') {
    payLoadParams.createdStart = dayjs('1969-01-01').format('YYYY-MM-DD');
  } else {
    payLoadParams.createdStart = dayjs(createdStart).format('YYYY-MM-DD');
  }

  if (typeof createdEnd === 'undefined') {
    payLoadParams.createdEnd = dayjs().format('YYYY-MM-DD');
  } else {
    payLoadParams.createdEnd = dayjs(createdEnd).format('YYYY-MM-DD');
  }

  try {
    // const { data } = await Services.getBeneficiaries(
    //   currentPlanList || createdStart || createdEnd ? payLoadParams : payload || availablePlans,
    // );
    // mudei ordem pra teste, testar a chamada assim
    const { data } = await Services.getBeneficiaries(
      currentPlanList || availablePlans || createdStart || createdEnd ? payLoadParams : payload,
    );
    return data;
    // return mocked100;
  } catch (err) {
    return err;
  }
}

export async function getCorporateClub(payload: GetCorporateClubParamType) {
  try {
    const { data } = await Services.getCorporateClub(payload);
    return data;
  } catch (error) {
    return error;
  }
}

export async function updateBeneficiary(payload: GetCorporateClub | GetCorporateClub[], allSelected?: boolean) {
  // edição de benefeciários
  const getToken = parseJwt(`${localStorage.getItem('session-token')}`);
  const planList = Array.isArray(payload) ? [payload[0].planList] : [payload.planList];
  const memberNumVoeBiz = Array.isArray(payload) ? [payload[0].memberNumVoeBiz] : [payload.memberNumVoeBiz];
  const selectAllpayload: any = {
    memberNumVoeBiz: memberNumVoeBiz,
    planList: planList[0],
  };
  try {
    if (allSelected) {
      const { data } = (await Services.updateAllBeneficiaries(selectAllpayload)) as any;
      return data;
    }
    const { data } = await Services.updateBeneficiary({
      corporateClubList: Array.isArray(payload) ? [...payload] : [payload],
    } as IUpdateBeneciaryList);
    return data;
  } catch (error) {
    return error;
  }
}

export async function removeOneBeneficiariePlans(member: any) {
  // serviço de exclusão de um membro e não de update
  const payload: any = {
    corporateClubList: [
      {
        cpf: `${member.cpf}`,
        memberNumVoeBiz: `${member.memberNumVoeBiz}`,
        planList: [],
      },
    ],
  };
  const { data } = await Services.updateBeneficiary(payload);

  return data;
}

export async function removeSelectedBeneficiariesPlans(selectedCheckBox: IMember[], allSelected: boolean) {
  // serviço de exclusão de vários membros e não de update
  const getToken = parseJwt(`${localStorage.getItem('session-token')}`);
  const excludeMembers = selectedCheckBox.map((member: any) => {
    return {
      cpf: member.cpf,
      memberNumVoeBiz: getToken?.sub.split('|')[2],
      planList: [],
    };
  });

  let payload;

  if (allSelected) {
    payload = {
      corporateClubList: excludeMembers[0],
    };
  }
  if (!allSelected) {
    payload = {
      corporateClubList: excludeMembers,
    };
    try {
      const { data } = await Services.updateBeneficiary(payload);
      return data;
    } catch (error) {
      return error;
    }
  }
}
